// src/components/ui/switch.jsx

import * as React from 'react';
import * as SwitchPrimitives from '@radix-ui/react-switch';
import { cn } from '@lib/utils';

const Switch = React.forwardRef(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      'sl-switch',
      'peer inline-flex h-5 w-9 shrink-0 cursor-pointer',
      'items-center rounded-full border-2 border-transparent',
      'shadow-sm transition-colors',
      'focus-visible:outline-none focus-visible:ring-2',
      'focus-visible:ring-primary-500 focus-visible:ring-offset-2',
      'focus-visible:ring-offset-white',
      'disabled:cursor-not-allowed disabled:opacity-50',
      'data-[state=checked]:bg-green-400',
      'data-[state=unchecked]:bg-gray-200',
      'dark:focus-visible:ring-primary-400',
      'dark:focus-visible:ring-offset-gray-950',
      'dark:data-[state=checked]:bg-primary-50',
      'dark:data-[state=unchecked]:bg-gray-800',
      className,
    )}
    {...props}
    ref={ref}>
    <SwitchPrimitives.Thumb
      className={cn(
        'sl-switch-thumb',
        'pointer-events-none block h-4 w-4',
        'rounded-full bg-white shadow-lg ring-0',
        'transition-transform',
        'data-[state=checked]:translate-x-4',
        'data-[state=unchecked]:translate-x-0',
        'dark:bg-gray-950',
      )}
    />
  </SwitchPrimitives.Root>
));

Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
